import athletesSlider from './modules/athletesSlider'

export default () => {

  const n = {};
  const init = () => {
    console.log('init pickupSec');
    n.root = document.getElementById('pickup');
    if (!n.root) {
      return;
    }

    athletesSlider();
  }


  init();

  return {}
};